import { useGlobal } from '@/utils/useGlobal';
import styles from './index.module.scss';
import { useState } from 'react';
import EcoImg from 'eco-design/base/eco-img';

export default function MountingOptions() {
    const { useLang } = useGlobal();
    const { t } = useLang('PowerOcean.MountingOptions');
    const [activeTab, setActiveTab] = useState('1');

    return (
        <div className={styles.mountingOptions}>
            <div className="container">
                <div className="solution-item">
                    <div className="text-box">
                        <h2 className="sub-title">
                            {t('label')} <span className="title">{t('title')}</span>
                        </h2>
                        <div className="desc">{t('desc')}</div>
                    </div>
                    {activeTab == '1' && (
                        <>
                            <div className="bg-img">
                                <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1746683448363/house1_pc.jpg" />
                            </div>

                            <div className="bg-img-h5">
                                <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1746683412234/house1_h5.jpg" />
                            </div>
                        </>
                    )}
                    {activeTab == '2' && (
                        <>
                            <div className="bg-img">
                                <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1746683412410/house2_pc.jpg" />
                            </div>

                            <div className="bg-img-h5">
                                <EcoImg pc="https://websiteoss.ecoflow.com/upload/image/1746683412898/house2_h5.jpg" />
                            </div>
                        </>
                    )}

                    <div className="tab-box">
                        <div className="tab-content">
                            <h3 className={`tab-item ${activeTab === '1' ? 'tab-item-active' : ''}`} onClick={() => setActiveTab('1')}>
                                {t('tab1')}
                            </h3>
                            <h3 className={`tab-item ${activeTab === '2' ? 'tab-item-active' : ''}`} onClick={() => setActiveTab('2')}>
                                {t('tab2')}
                            </h3>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export const getStaticProps = async () => {
    return {
        props: {},
    };
};
